import * as Constants from "../constants/socialPlatformConstants";

// Sort order based on groups, and then race
const classificationSort = {
    "Women Owned": 1,
    "LGBTQ": 2,
    "Minority": 3,
    "Veteran Owned": 4,
    "Disability": 5,
    "Asian": 6,
    "Black Owned": 7,
    "Hispanic": 8,
    "Native American": 9,
    "Small Business": 10, 
};

/**
 * Helper function to determine which sticker image to show IF business applied for more than one
 * @param {array} classifications 
 */
export function getSortedDecalForDisplay(classifications) {
    return classifications.sort(function(classification1, classification2) {
        return classificationSort[classification1] - classificationSort[classification2];
    })
}

export function parseTermField(field) {
    if (!field || field === 'off') return 'No';
    if (field === 'on') return "Yes";
    return "No";
}

export function renderSocialUrl(platformName, value) {
    if (platformName && value) {
        let urlPrefix;
        switch(platformName.toLowerCase()) {
            case Constants.INSTAGRAM.toLowerCase():
                urlPrefix = "https://instagram.com/"
                break;
            case Constants.PINTEREST.toLowerCase():
                urlPrefix = "https://pinterest.com/"
                break;
            case Constants.SNAPCHAT.toLowerCase():
                urlPrefix = "https://snapchat.com/"
                break;
            case Constants.TIKTOK.toLowerCase():
                urlPrefix = "https://tiktok.com/"
                break;
            case Constants.TWITCH.toLowerCase():
                urlPrefix = "https://twitch.com/"
                break;
            case Constants.X.toLowerCase():
                urlPrefix = "https://x.com/"
                break;
            case Constants.YOUTUBE.toLowerCase():
                urlPrefix = "https://youtube.com/"
                break;
            case Constants.OTHER.toLowerCase():
                urlPrefix = "https://"
                break;
            default:
                // since we're not sure which platform, do not attempt to append prefix
                urlPrefix = "";
        }
        // remove the @ sign in case there is one
        if (value.startsWith("@")) {
            value = value.substring(1);   
        }

        return urlPrefix + value;
    }
    return value;
}

export function prefixUrl(url) {
    if (!url.toLowerCase().startsWith("http")) {
        return "https://" + url;
    } 
    return url;
}

export function getCountry(countryShortCode) {
    if (!countryShortCode) return null;
    if (countryShortCode === 'US') {
        return "USA";
    }
    else if (countryShortCode === 'CA') {
        return "Canada";
    }
    else {
        return null;
    }
}

export function capitalizeFirstLetter(string) {
    if (string.length === 0) {
        return ""; // Handle empty string case
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function hasClassification(data, property) {
    if (!data) return false;
    if (data.includes(property)) {
        return true;
    }
    return false;
}

export function hasBusinessTerms(data, property) {
    if (!data) return false;
    if (data[property] && data[property].toLowerCase() === 'on') {
        return true;
    }
    return false;
}